import { render, staticRenderFns } from "./batchSection.vue?vue&type=template&id=35f89e3c&scoped=true"
import script from "./batchSection.vue?vue&type=script&lang=js"
export * from "./batchSection.vue?vue&type=script&lang=js"
import style0 from "./batchSection.vue?vue&type=style&index=0&id=35f89e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f89e3c",
  null
  
)

export default component.exports